// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../node_modules/postcss-loader/dist/cjs.js!../style/theme.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.breadcrumbSection_rOHVb {
  padding: 0.1px; /* Prevent margin collapsing */
  white-space : nowrap;
  height:100%;
  width:100%;
}
.breadcrumbSection_rOHVb .breadcrumbs_lntg4 {
  z-index:1;
  position :fixed;
  height : 36px;
  width:100%;
  background-color:var( --background );
  border-radius:0;
  border-bottom:0px solid var( --light-grey );
  margin : 0;
}

.breadcrumbSection_rOHVb .breadcrumbs_lntg4 li{
  color : var( --grey );
}
.breadcrumbSection_rOHVb .content_redC_ {
  position:absolute;
  top:40px;
  bottom:0;
  width:100%;
  overflow:auto;
}
.breadcrumbSection_rOHVb.collapse_yyrDd .content_redC_ {
  top:0px;
}

.breadcrumbSection_rOHVb.collapse_yyrDd .breadcrumbs_lntg4 {
  height:0px;
  padding : 0;
  margin : 0;
}

`, "",{"version":3,"sources":["webpack://./src/views/breadcrumbs.css"],"names":[],"mappings":"AAEA;EACE,cAAc,EAAE,8BAA8B;EAC9C,oBAAoB;EACpB,WAAW;EACX,UAAU;AACZ;AACA;EACE,SAAS;EACT,eAAe;EACf,aAAa;EACb,UAAU;EACV,oCAAoC;EACpC,eAAe;EACf,2CAA2C;EAC3C,UAAU;AACZ;;AAEA;EACE,qBAAqB;AACvB;AACA;EACE,iBAAiB;EACjB,QAAQ;EACR,QAAQ;EACR,UAAU;EACV,aAAa;AACf;AACA;EACE,OAAO;AACT;;AAEA;EACE,UAAU;EACV,WAAW;EACX,UAAU;AACZ","sourcesContent":["@import \"../style/theme.css\";\n\n.breadcrumbSection {\n  padding: 0.1px; /* Prevent margin collapsing */\n  white-space : nowrap;\n  height:100%;\n  width:100%;\n}\n.breadcrumbSection .breadcrumbs {\n  z-index:1;\n  position :fixed;\n  height : 36px;\n  width:100%;\n  background-color:var( --background );\n  border-radius:0;\n  border-bottom:0px solid var( --light-grey );\n  margin : 0;\n}\n\n.breadcrumbSection .breadcrumbs li{\n  color : var( --grey );\n}\n.breadcrumbSection .content {\n  position:absolute;\n  top:40px;\n  bottom:0;\n  width:100%;\n  overflow:auto;\n}\n.breadcrumbSection.collapse .content {\n  top:0px;\n}\n\n.breadcrumbSection.collapse .breadcrumbs {\n  height:0px;\n  padding : 0;\n  margin : 0;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"breadcrumbSection": `breadcrumbSection_rOHVb`,
	"breadcrumbs": `breadcrumbs_lntg4`,
	"content": `content_redC_`,
	"collapse": `collapse_yyrDd`
};
export default ___CSS_LOADER_EXPORT___;
